// extracted by mini-css-extract-plugin
export default {"wrapper":"KA-z","viewport":"LA-z","container":"MA-z","slide":"NA-z"};